export class CalendarModel {
    constructor(
        public id: any,
        public calendarType: string,
        public payroll_due_dt: Date,
        public pay_dt: Date,
        public valid_from_dt: Date,
        public valid_to_dt: Date,
        public active_flag: string,
        public cal_run_id: string,
        public unlock: string,
        public off_cycle: string,
        public created_dt: Date,
        public created_by: string,
        public updated_dt: Date,
        public updated_by: string,
        public editMode: boolean,
        public commPeriod: string,
        public comment: string,
        public loggedInUser: string,
        public issalesrepaccess: string
    ) { }


}
